module.exports = __webpack_public_path__ + "img/dexon.da468160.svg";